import { PictureInfo } from "src/app/core/survey/shared/components/photo-and-remark/photo-viewmodel";

export {};
declare global {
  interface Array<T> {
    changePhotoIndex(index1: number, index2: number);
  }
}

Array.prototype.changePhotoIndex = function <T extends PictureInfo>(
  this: T[],
  index1: number,
  index2: number
): void {
  if (!index1 && !index2) throw Error("Index can't be undefined");
  const tmpValue1 = this[index2];
  const tmpValue2 = this[index1];

  this[index2] = tmpValue2;
  this[index1] = tmpValue1;

  tmpValue2.index = index2;
  tmpValue1.index = index1;
};
